import { MatchingStrategy } from "@closerplatform/spinner-openapi";
import { AutoComplete } from "@fidget/common/components/form/autoComplete/autoComplete";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { mapStrategyToString } from "@fidget/common/utils/urlMappingHelpers";
import React, { useState } from "react";
import { ExistingMappingFormType } from "../../../tags/taggingSettings/types";
import styles from "../filterStyles.css";
import { useFilterWrapper } from "../listFilterWrapper/useFilterWrapper";
import { useSettingsListFilters } from "../useListFilter/useListFilter";
import { FilterLabel } from "./filterLabel";

const filterId = "MatchingStrategyFilter";

export const MatchingStrategyFilter = () => {
  const [isPickingStrategy, setIsPickingStrategy] = useState<boolean>(false);

  const { activeFilters, deactivateFilter } = useSettingsListFilters<ExistingMappingFormType>();
  const { selectedFilters, selectFilter, deselectFilter } =
    useFilterWrapper<ExistingMappingFormType>();

  const activated = selectedFilters[filterId] || activeFilters[filterId];

  const handleClick = () => {
    if (activated) {
      if (!!activeFilters[filterId]) {
        deactivateFilter(filterId);
      }
      if (!!selectedFilters[filterId]) {
        deselectFilter(filterId);
      }
    } else {
      setIsPickingStrategy(true);
    }
  };

  const handleStrategyPicked = (value: MatchingStrategy | "") => {
    if (value) {
      selectFilter({
        predicate: (item) => item.$.matchingStrategy.$ === value,
        description: intl.formatMessage("settings.tagging.filters.rule"),
        content: mapStrategyToString(value),
        filterId
      });
    }
    setIsPickingStrategy(false);
  };

  return isPickingStrategy ? (
    <AutoComplete<MatchingStrategy>
      onOutsideClick={() => setIsPickingStrategy(false)}
      className={styles.picker}
      onChange={handleStrategyPicked}
      itemsProvider={() => Object.values(MatchingStrategy)}
      itemToString={mapStrategyToString}
      readOnly
      initialIsOpen
      inputValue={intl.formatMessage("settings.tagging.filters.rule")}
    />
  ) : (
    <FilterLabel
      active={!!activated}
      text={intl.formatMessage("settings.tagging.filters.rule")}
      content={activated?.content}
      onClick={handleClick}
    />
  );
};
